// Custom notification manager for Shopify
(function () {
  const overlay = document.createElement('div');
  overlay.id = 'notification-overlay';
  document.body.appendChild(overlay);

  function createUUID() {
    var pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  }

  const NotificationManager = {
    notifications: [],
    create(notify) {
      const defaultNotify = {
        id: createUUID(),
        type: 'info',
        title: null,
        message: null,
        timeOut: 5000
      }; 
      const notification = Object.assign(defaultNotify, notify);
      this.notifications.push(notification);
      this.renderNotification(notification);
    },
    info(message, title, timeOut) {
      this.create({ type: 'info', message, title, timeOut });
    },
    success(message, title, timeOut) {
      this.create({ type: 'success', message, title, timeOut });
    },
    error(message, title, timeOut) {
      this.create({ type: 'error', message, title, timeOut });
    },
    remove(id) {
      this.notifications = this.notifications.filter(n => n.id !== id);
      const element = document.getElementById(`notification-${id}`);
      if (element) element.remove();
    },
    renderNotification({ id, type, title, message, timeOut }) {
      const notification = document.createElement('div');
      notification.id = `notification-${id}`;
      notification.className = `notification notification-${type}`;
      notification.innerHTML = `
        <div class="notification-content">
          ${title ? `<h4>${title}</h4>` : ''}
          <p>${message}</p>
          <button onclick="NotificationManager.remove('${id}')">×</button>
        </div>
      `;
      overlay.appendChild(notification);
      if (timeOut > 0) {
        setTimeout(() => { 
          console.log(id);
          console.dir(document.getElementById(`notification-${id}`));
          this.remove(id) 
        }, timeOut);
      }
    }
  };

  window.NotificationManager = NotificationManager;
})();